import * as constants from './types';
import * as selectors from './selector';
import * as actions from './actions';
import reducer from './reducer';

export default { constants, reducer, selectors, actions };
